import { StepsContext } from '../context/StepsContext';
import { useContext, useState } from 'react';
import { useEffect } from 'react';
import { Question } from '@iq-solutions/nida-shared';

interface QuestionInt {
  onSelection(questionId: number, value: Array<string>, drugs: Array<string>): void;
  questionData: Question;
}

const question = ({ questionData, onSelection }: QuestionInt): JSX.Element => {
  const qContext = useContext(StepsContext);
  const [sliderVal, setSliderVal] = useState(
    qContext.answers[questionData.id]?.answer.length > 0
      ? qContext.answers[questionData.id].answer
      : 0,
  );
  const [checkAnswers, setCheckAnswers] = useState<Array<string>>(
    qContext.answers[questionData.id] ? qContext.answers[questionData.id].answer : [],
  );
  let drugs: Array<string> = [];

  for (const drug of questionData.drugs) {
    drugs.push(drug);
  }
  useEffect((): void => {
    onSelection(questionData!.id, checkAnswers, drugs);
  }, [checkAnswers]);

  const onValueChange = (evt: React.ChangeEvent<HTMLInputElement>): void => {
    if (questionData.fieldType === 'slider') {
      setSliderVal(Number(evt.target.value));
      onSelection(questionData!.id, [evt.target.value], drugs);
    } else {
      let answer = evt.target.value.split(' (')[0];
      if (evt.target.value !== 'none of the above') {
        setCheckAnswers((prev) => {
          if (evt.target.checked) {
            return [...prev.filter((value) => value !== 'none of the above'), answer];
          } else {
            return prev.filter((value) => value !== answer);
          }
        });
      } else {
        setCheckAnswers(evt.target.checked ? ['none of the above'] : []);
      }
    }
  };

  return (
    <div className="question">
      <h2>
        {questionData.title}
        {questionData.description === '' ? (
          ''
        ) : (
          <span dangerouslySetInnerHTML={{ __html: questionData.description }}></span>
        )}
      </h2>
      <form>
        {questionData.fieldType === 'slider' ? (
          <div className="slider">
            <label>
              <input
                type="number"
                min="0"
                max="365"
                placeholder="Enter the number of days"
                aria-invalid="false"
                value={sliderVal}
                onChange={onValueChange}
              />
              days
            </label>
            <input
              type="range"
              min="0"
              max={Number(questionData.answers[0])}
              value={sliderVal}
              onChange={onValueChange}
            />
            <p className="range-tooltip">
              Click and drag on the bar above to select the number of days or type the number of
              days in the field above.
            </p>
          </div>
        ) : (
          <div className="checkboxes-container">
            {questionData?.answers.map((txt: string, index: number) => (
              <div key={questionData.id + index} className="radio-set">
                <input
                  type="checkbox"
                  value={txt}
                  id={questionData.id + txt}
                  name={questionData?.title}
                  checked={checkAnswers.indexOf(txt.split(' (')[0]) > -1}
                  onChange={onValueChange}
                />
                <label htmlFor={questionData.id + txt}>
                  <span>
                    {checkAnswers.indexOf(txt.split(' (')[0]) > -1 ? (
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 1280">
                        <path
                          fill="currentColor"
                          d="M1575 310q0 40-28 68l-724 724l-136 136q-28 28-68 28t-68-28l-136-136L53 740q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295l656-657q28-28 68-28t68 28l136 136q28 28 28 68z"
                        />
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1536 1536">
                        <path
                          fill="currentColor"
                          d="M768 224q-148 0-273 73T297 495t-73 273t73 273t198 198t273 73t273-73t198-198t73-273t-73-273t-198-198t-273-73zm768 544q0 209-103 385.5T1153.5 1433T768 1536t-385.5-103T103 1153.5T0 768t103-385.5T382.5 103T768 0t385.5 103T1433 382.5T1536 768z"
                        />
                      </svg>
                    )}
                  </span>
                  {txt}
                </label>
              </div>
            ))}
          </div>
        )}
      </form>
    </div>
  );
};
export default question;
